import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { Export } from './Export';
import ExportErrorResponse from './ExportErrorResponse';

export interface Result {
	readonly export: Export;
}

export const createEvidenceExport = async (client: ApiClient, userId: string, id: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{id}/export-evidence');

	try {
		const response = await client.fetch(url.expand({ userId, id }), {
			method: 'POST',
		});
		return response.json();
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ExportErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
